import { createSlice } from "@reduxjs/toolkit";

const resetPasswordSlice = createSlice({
  name: "resetPassword",
  initialState: {
    data: null,
    isLoading: false,
    error: null,
    success: null,
  },
  reducers: {
    resetPasswordStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = null;
    },
    resetPasswordSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    resetPasswordFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    clearResetPasswordState(state) {
      state.isLoading = false;
      state.error = null;
      state.success = null;
      state.data = null;
    },
  },
});

export const {
  resetPasswordStart,
  resetPasswordSuccess,
  resetPasswordFailure,
  clearResetPasswordState,
} = resetPasswordSlice.actions;
export default resetPasswordSlice.reducer;
